export const dummyCaptains = {
  result: {
    total: 2,
    data: [
      {
        id: 1,
        name: "Ravi Kumar",
        phone: "9876543210",
        createdAt: "21/03/2026 10:30 AM",
        status: 1,
        vehicles: [
          {
            registrationNumber: "MH12AB1234",
            model: "Swift Dzire",
            color: "White",
            seatCapacity: 4,
            insuranceExpiry: "12-12-2026",
            pollutionExpiry: "10-10-2026",
          },
        ],
        documents: [
          {
            id: 101,
            type: "Driving License",
            image: "https://picsum.photos/536/354",
            status: null,
          },
          {
            id: 102,
            type: "RC",
            image: "https://picsum.photos/536/354",
            status: 1,
          },
        ],
      },
      {
        id: 2,
        name: "Amit Sharma",
        phone: "9123456780",
        createdAt: "20/03/2026 09:15 AM",
        status: 0,
        vehicles: [
          {
            registrationNumber: "DL8CAF5032",
            model: "Hyundai i20",
            color: "Black",
            seatCapacity: 4,
            insuranceExpiry: "05-11-2026",
            pollutionExpiry: "02-09-2026",
          },
        ],
        documents: [
          {
            id: 103,
            type: "Insurance",
            image: "https://picsum.photos/536/354",
            status: 2,
          },
        ],
      },
    ],
  },
};